exports = module.exports = require("/home/kwok/projects/brewplanner/brewplanner-ui/node_modules/css-loader/cssToString.js")();
exports.push([module.id, ".bp-custom-overlay{display:none;background-color:rgba(51,51,51,.63);height:100vh;width:100vw;z-index:8;position:fixed}.bp-custom-overlay.is-visible{display:initial}.bp-custom-overlay.is-visible.has-text:before{content:attr(data-text);position:fixed;top:50%;left:45%;background-color:#fff;padding:10px 20px;border-radius:5px;box-shadow:1px 2px 11px 2px;border:solid 2px #ddd;font-size:18px;font-weight:300}", ""]);


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/CustomOverlay/CustomOverlay.scss
 ** module id = 265
 ** module chunks = 0
 **/